module.exports = __webpack_public_path__ + "static/img/1_11.8566b808.jpg";